module.exports = __webpack_public_path__ + "img/yhycdzq.5905124c.jpg";